import React from 'react';
import styled from 'styled-components';
import mondrian from 'core/config/theme';

export const Div = styled.div`
  margin-bottom: ${mondrian.spacingStackMd};
`;

export default function ButtonGroup(props) {
  return <Div>{props.children}</Div>;
}
